<template>
    <div class="row date-filter pad-top">
        <div class="col-12">
            <div class="row actions">
                <div class="col-12 action">
                    <DatePicker :disabled="disabledDates" :format="DatePickerFormat" :language="Storage.language" :maximumView="'month'"
                                :minimumView="'month'" v-model="Storage.selectedMonthFrom">></DatePicker>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-12 action">
                    <button :disabled="disabled" @click="this.reset" class="btn btn-info reset"><i
                            class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import Storage from '../../api/Storage'
import { dropdown } from 'vue-strap'
export default {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'MonthFromFilter',
  components: {
    DatePicker,
    dropdown
  },
  data () {
    return {
      Storage: Storage,
      DatePickerFormat: 'yyyy-MM',
      disabledDates: {
        to: new Date(2017, 7, 31)
      }
    }
  },
  methods: {
    yesterday () {
      Storage.selectedMonthFrom = new Date()
    },
    getMaxDate (y, m) {
      if (m === 1) {
        return y % 4 || (!(y % 100) && y % 400) ? 28 : 29
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31
    },
    week () {
      Storage.selectedMonthFrom = new Date()
    },
    month () {
      let date = new Date()
      date.setDate(1)
      Storage.selectedMonthFrom = date
    },
    thisMonth () {
      Storage.selectedMonthFrom = new Date()
    },
    lastMonth () {
      let date = new Date()

      date = new Date()
      date.setMonth(date.getMonth() - 1)
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()))
      Storage.selectedMonthFrom = date
    },
    reset () {
      this.month()
    }
  },
  mounted: function () {
    Storage.selectedMonthFrom = new Date()
    this.$root.$on('filters_reset_all', () => {
      this.reset()
    })
  }
}
</script>

<style scoped>
  .pad-top{
      padding-top:5px;
  }
</style>



// WEBPACK FOOTER //
// MonthFromFilter.vue?0e889e50